<script>
import constants from '../common/constants';

export default {
    methods: {
      getLoginProviderComponentName(userProviderName) {
        switch (userProviderName.toLowerCase()) {
          case constants.PROVIDER_COGNITO.toLowerCase():
            return "LoginCognitoInitializer";
        }
      }
    }
}
</script>